import { useState } from 'react';
import { Loader, Select, Title } from '@mantine/core';
import { TAccount } from '../components/TAccount';
import { useUserContext } from '../providers/UserContext';
import { useLanguage } from '../providers/LanguageContext';

function MemberAccount() {
  const { currentPerson, myChildren } = useUserContext();
  const { t } = useLanguage();
  const mp = t.memberProfile;
  const [selectedPersonId, setSelectedPersonId] = useState<number | null>(null);

  if (!currentPerson) return <Loader size="md" />;

  const viewedId = selectedPersonId ?? currentPerson.id;

  return (
    <>
      <Title order={2} mb="md">{t.memberAccount.title}</Title>
      {myChildren.length > 0 && (
        <Select
          label={mp.viewingAs}
          data={[
            { value: String(currentPerson.id), label: `${currentPerson.firstName} ${currentPerson.lastName} (${mp.myself})` },
            ...myChildren.map((c) => ({ value: String(c.id), label: `${c.firstName} ${c.lastName}` })),
          ]}
          value={String(viewedId)}
          onChange={(val) => val && setSelectedPersonId(Number(val))}
          mb="md"
          w={280}
          allowDeselect={false}
        />
      )}
      {/* TAccount only fetches on mount (empty effect deps) — key forces a
          remount so switching the viewed person actually reloads bookings. */}
      <TAccount key={viewedId} personId={viewedId} readOnly />
    </>
  );
}

export default MemberAccount;
